"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrefersReducedMotion = usePrefersReducedMotion;
var _react = require("react");
// ----
const QUERY = "(prefers-reduced-motion: no-preference)";
const isRenderingOnServer = typeof window === "undefined";
const getInitialState = function () {
  // For our initial server render, we won't know if the user
  // prefers reduced motion, but it doesn't matter. This value
  // will be overwritten on the client, before any animations
  // occur.
  return isRenderingOnServer ? true : !window.matchMedia(QUERY).matches;
};
function usePrefersReducedMotion() {
  let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_isMatch) {};
  const [prefersReducedMotion, setPrefersReducedMotion] = (0, _react.useState)(getInitialState);
  (0, _react.useEffect)(function () {
    const mediaQueryList = window.matchMedia(QUERY);
    const listener = function (event) {
      setPrefersReducedMotion(!event.matches);
      callback(!event.matches);
    };
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener("change", listener);
    } else {
      mediaQueryList.addListener(listener);
    }
    return function () {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener("change", listener);
      } else {
        mediaQueryList.removeListener(listener);
      }
    };
  }, []);
  return prefersReducedMotion;
}
// ----